import React, { useState, useEffect } from "react";
import { Container, Col, Image, Row, Card, Button, Modal, Form, FloatingLabel } from "react-bootstrap";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";
import { NavLink, useNavigate, useParams } from 'react-router-dom'
import Modals from '../components/Modals';
import AllHeader from "../components/AllHeader";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import NotInfo from "../components/NotInfo";
import BigLoader from "../components/BigLoader";
import useCheckUser from "../custom-hooks/useCheckUser";


function MunicipalNews() {
    const [load, setLoad] = useState(false);
    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [seenFile, setSeenFile] = useState([]);
    const [show, setShow] = useState(false);
    const [isSearch, setIsSearch] = useState(false);
    const UserID = localStorage.getItem("UserId");
    const navigate = useNavigate();
    const params = useParams();

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

  // Example usage of the custom hook
  useCheckUser(UserID); // Replace UserID with the actual user ID value

    useEffect(() => {
            setLoad(true)
            const axios = require("axios");
            axios.post(apiUrl + "GetNewsList", {
                type_news: params.requestId,
                Name: title,
                Date: typeof date !== 'string' ? new Date(date).toLocaleDateString("fa-IR") : date,
                Uid: UserID,
            }
            ).then((res) => {          
                if (res.data.result === "true") {
                    setSeenFile(res.data.data)
                    setLoad(false)
                } else {

                }
            });
    }, [params.requestId,isSearch]);

    // search function
    const searchHandler = () => {
        if (isSearch === false) {
            setIsSearch(true)
        } else {
            setIsSearch(false)
        }
        setShow(false);
    }

    //Focus on the Next Field
    const handleEnter = (event) => {
        if (event.key.toLowerCase() === "enter") {
            const form = event.target.form;
            const index = [...form].indexOf(event.target);
            form.elements[index + 1].focus();
            event.preventDefault();
        }
    };

    return (
        <div>
            <AllHeader>
                {(() => {
                    switch (params.requestId) {
                        case '1':
                            return (<span>اخبار شهرداری</span>)

                        case '2':
                            return (<span>اخبار شهروندی</span>)

                        case '3':
                            return (<span>راهنمای شهروندی</span>)

                        case '4':
                            return (<span>رویدادهای فرهنگی</span>)

                        case '5':
                            return (<span>مصوبات شورا</span>)

                        default:
                            return (<span> اخبار</span>)
                    }
                })()}
            </AllHeader>

            <Container>
                <Row className="justify-content-start">
                    <Col xs={12} className="text-center rgc-title">
                        {/* search part */}
                        <Row>
                            <Col xs={2} className="rgc-search-position text-center">
                                <Button
                                    className="btn rgc-search-btn"
                                    onClick={handleShow}
                                >
                                    <i className="fa fa-search" aria-hidden="true"></i>
                                </Button>
                            </Col>
                        </Row>
                    </Col>

                    {/* show items related of title */}
                    {load === false && seenFile.length === 0 ?
                     <NotInfo />
                     :
                     seenFile.map((data, index) => {
                        return (
                            <Col xs={12} sm={6} lg={4} className="rgc-news-item" key={index}>
                                <NavLink to={"/Internalnews/" + data.Id} state={data.Tittle} >
                                    <Card className="rgc-news">
                                        <Row>
                                            <Col xs={5} className="rgc-img-news">
                                                {data.Type==2 ? <Image src={'data:image/png;base64,'+data.Pic} alt="" fluid />
                                                    :
                                                    <Image src={IPUrl + "/UploadedFile/Session/Ssn/" + data.Pic} alt="" fluid />
                                                }

                                            </Col>
                                            <Col xs={7} className="rgc-text-news">
                                                {data.Tittle.length > 60 ? <p>{data.Tittle.substring(0, 60) + "..."}</p> : <p>{data.Tittle} </p>}
                                                {data.Chekideh.length > 60 ? <p>{data.Chekideh.substring(0, 60) + "..."}</p> : <p>{data.Chekideh} </p>}
                                            </Col>
                                        </Row>
                                    </Card>
                                </NavLink>
                            </Col>
                        )
                    })                                         
                    }
                </Row>
            </Container>

            <Modals show={show} handleClose={handleClose}>
                {/* clildren part */}
                <Form>
                    <Row className='justify-content-start g-3'>
                        <Col xs={12} md={6} className="form-outline  rgc-input-icons">
                            <FloatingLabel
                                controlId="floatingInput"
                                label="عنوان"
                            >
                                <i className="far fa-calendar-check" aria-hidden="true"></i>
                                <Form.Control
                                    type="text"
                                    autoComplete="off"
                                    placeholder="عنوان"
                                    className="rgc-profile-input"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    onKeyDown={handleEnter}
                                />
                            </FloatingLabel>
                        </Col>

                        <Col xs={12} md={6} className="form-outline rgc-icon-date">
                            <Form.Group>
                                <i className="far fa-calendar-check rgc-date" aria-hidden="true"></i>
                                <DatePicker
                                    placeholder="تاریخ"
                                    calendar={persian}
                                    locale={persian_fa}
                                    calendarPosition="bottom-right"
                                    value={date}
                                    onChange={setDate}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
                <Modal.Footer className="rgc-modal-button">
                    <Button onClick={searchHandler} className="rgc-btn">
                        جستجو
                    </Button>
                </Modal.Footer>
            </Modals>

            {/* <BigLoader loading={load} /> */}
        </div>
    );
}

export default MunicipalNews;
